const zoneTypes = ['ZoneToZone', 'Radius'] as const;
export type ZoneType = typeof zoneTypes[number];

export const parseZoneType = (value: string): ZoneType => {
  if (zoneTypes.includes(value as ZoneType)) {
    return value as ZoneType;
  }
  throw new Error(`${value} is not a valid ZoneType`);
};
